import { FormattedMessage } from "react-intl";

import Functions from "../../../../../../components/ai/settings/escalations";

export default function Escalations(){

  return (
    <div className="settings-presentation">
      <h4>
        <FormattedMessage id="ai.settings.escalations" />
      </h4>
      <p className="color-step-700 fs-3">
        <FormattedMessage id="ai.settings.escalations.desc" />
      </p>
      <hr />
      <Functions />
    </div>
  );
};
